import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { environment } from "../../../environments/environment";
import { timeout, catchError } from 'rxjs/operators';
import { Global } from "../lib/global";
@Injectable()
export class NoticeItemService {
  extraOptions: any;
  constructor(public http: HttpClient, public global: Global) { }

  collection(id: number, search, order) {
    let arrayModel = [];

    return new Promise((resolve, reject) => {
      this.fetchAll(id, search, order).subscribe(
        (res) => {
          for (const noticeItem of res.data) {
            arrayModel.push(noticeItem);
          }
          resolve(arrayModel);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  entity(id) {
    return new Promise((resolve, reject) => {
      this.find(id).subscribe(
        (res) => {
          const notice = res.data;
          notice.notice_id = res.data.notice.id;
          resolve(notice);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  fetchItemResult(id: number, individual: boolean): Observable<any> {
    const url = `${environment.baseUrl}/api/v2/admin/notice/item/result/${id}?individual=${individual}`;
    const body = { individual };

    return this.http.post(url, body, this.getHeaders())
      .pipe(
        timeout(10000),
        catchError((error) => {
          console.error('[fetchItemResult]', error);
          throw error;
        })
      );
  }

  fetchItemTable(id: number, projeto: string, instituicao: string, sinopse: string): Observable<any> {
    const url = `${environment.baseUrl}/api/v2/admin/notice/item/result/${id}`;
    const body = { projeto, instituicao, sinopse };

    return this.http.post(url, body, this.getHeaders())
      .pipe(
        timeout(10000),
        catchError((error) => {
          console.error('[fetchItemResult]', error);
          throw error;
        })
      );
  }

  updateItemTable(id: number, projeto: string, instituicao: string, sinopse: string): Observable<any> {
    const url = `${environment.baseUrl}/api/v2/admin/notice/item/result/${id}`;
    const body = { projeto, instituicao, sinopse };

    return this.http.put(url, body, this.getHeaders())
      .pipe(
        timeout(10000),
        catchError((error) => {
          console.error('[fetchItemResult]', error);
          throw error;
        })
      );
  }

  getItemResult(id: number, individual: boolean): Observable<any> {
    const url = `${environment.baseUrl}/api/v2/admin/notice/item/result/${id}?individual=true`;

    return this.http.get(url, { ...this.getHeaders() })
      .pipe(
        timeout(10000),
        catchError((error) => {
          console.error('[getItemResult]', error);
          throw error;
        })
      );
  }

  getItemTableResult(id: number): Observable<any> {
    const url = `${environment.baseUrl}/api/v2/admin/notice/item/result/${id}`;

    return this.http.get(url, { ...this.getHeaders() })
      .pipe(
        timeout(10000),
        catchError((error) => {
          console.error('[getItemResult]', error);
          throw error;
        })
      );
  }

  fetchAll(
    id,
    search: string = "",
    order: "a-z" | "z-a" | "data" | "" = ""
  ): Observable<any> {
    return this.http.get(
      environment.baseUrl +
      `/api/v2/admin/notice/folder/${id}/items?search=${search}&order=${order}`,
      this.getHeaders()
    );
  }

  find(id: number): Observable<any> {
    console.log("[find]");

    return this.http.get(
      environment.baseUrl + "/api/v2/admin/notice/item/" + id,
      this.getHeaders()
    );
  }

  persist(notice): Observable<any> {
    if (notice.id) {
      return this.http.put(
        environment.baseUrl + "/api/v2/admin/notice/item/" + notice.id,
        notice,
        this.getHeaders()
      );
    } else {
      return this.http.post(
        environment.baseUrl + "/api/v2/admin/notice/item",
        notice,
        this.getHeaders()
      );
    }
  }

  delete(id: number): Observable<any> {
    return this.http.delete(
      environment.baseUrl + `/api/v2/admin/notice/item/${id}`,
      this.getHeaders()
    );
  }

  deleteResult(id: number): Observable<any> {
    return this.http.delete(
      environment.baseUrl + `/api/v2/admin/notice/item/result/${id}`,
      this.getHeaders()
    );
  }

  getItems(id): Observable<any[]> {
    return this.http.get<any[]>(
      `https://api.tecnologiaasap.com.br/api/v2/admin/notice/item/result/${id}`
    );
  }



  getHeaders(): { headers: HttpHeaders } {
    const token = sessionStorage.getItem("token");
    const headerOptions = {
      Authorization: token,
      Accept: "application/json",
    };
    return { headers: new HttpHeaders(headerOptions) };
  }

  generateReportExcel(folder_id: number, id: number) {
    const user = this.global.loggedUser();
    console.log("[user]", user);

    window.open(`https://api.tecnologiaasap.com.br/api/v2/client/export/projeto/list/idv/${folder_id}/${id}?client_id=` + user.client_id, '_blank');
  };
}



// WEBPACK FOOTER //
// ./src/app/@core/services/notice-item.service.ts